// Client-side mirror of the game worker's AssembledDuel payload
// (apps/game/src/duel/types.ts). Play is fully client-side like Connections —
// the payload includes winners; the worker re-derives the score on POST.

export type DisciplineId =
  | 'output'
  | 'weight'
  | 'power-to-weight'
  | 'rarity'
  | 'vintage';

export interface DuelCarView {
  id: string;
  label: string;
  value: number;
  display: string;
  cars_slug?: string;
}

export interface DuelRoundView {
  a: DuelCarView;
  b: DuelCarView;
  winner: 'a' | 'b';
  fun_fact: string;
}

export interface CallStatView {
  id: DisciplineId;
  label: string;
  player_display: string;
  opponent_display: string;
  player_wins: boolean;
}

export interface DuelCallView {
  player: { id: string; label: string; cars_slug?: string };
  opponent: { id: string; label: string; cars_slug?: string };
  stats: CallStatView[];
  fun_fact: string;
}

export interface AssembledDuel {
  id: string;
  number: number;
  date: string;
  discipline: { id: DisciplineId; label: string; question: string };
  rounds: DuelRoundView[];
  call: DuelCallView;
  max_score: number;
}

export interface DuelResult {
  correct: number;
  callWon: boolean;
  score: number;
  picksLog: string[];
  disciplineBest?: number | null;
}

export interface DuelBoardResponse {
  puzzle: AssembledDuel;
  date: string;
  result: DuelResult | null;
}

export const DUEL_ROUNDS = 9;
export const DUEL_MAX_SCORE = 11;
